module.exports = __webpack_public_path__ + "media/images/office-4-e4da757a.jpg";